<h2>
  <a uiSref="a.workflow.detail" [uiParams]="{id: workflow.id}" ngbTooltip="Zurück zum Vorgang">
    <i class="fa fa-chevron-left"></i>
    Vorgang: {{ workflow.id }}
  </a>
</h2>

<finder-upload [category]="category" [initial]="initial" searchType="workflow" [id]="workflow.id"></finder-upload>
